<div class="caller-name-container">
  <div class="phone-info">
    <span nz-icon nzType="phone" nzTheme="outline"></span>
    <span class="phone-number">{{ nzModalData.phoneNumber }}</span>
  </div>

  <p class="prompt-text">What is the caller's name?</p>

  <input nz-input
    placeholder="Customer name"
    [(ngModel)]="customerName"
    (keyup.enter)="confirm()" />

  <div class="modal-actions">
    <button nz-button nzType="primary" (click)="confirm()">Continue</button>
    <button nz-button nzType="default" (click)="skip()">Skip</button>
  </div>
</div>
